import React from 'react';
import { Box, Button } from '@mui/material';

const SharedSnapshotBanner = () => (
  <Box
    sx={{
      mt: 2,                     // space under the main header
      textAlign: 'center',
      py: 3,                     // slightly taller than before
      px: 3,
      color: 'text.secondary',
      borderBottom: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'rgba(0,0,0,0.02)',
      fontSize: '0.875rem'
    }}
  >
    {/*  —— sentence ——  */}
    This is a read-only copy of a Research Project created with&nbsp;
    <Box component="span" sx={{ fontWeight: 600, color: 'primary.main' }}>
      InstantFlows
    </Box>
    .

  </Box>
);

export default SharedSnapshotBanner;
